import Boundary from "./boundary";

class Volume extends Boundary {
    branchId;

    constructor(props) {
        super();
        this.volumeName = props.name;
        this.branchId = props.id;
        this.modelId = getModelIdFromBranchId(this.branchId);
        this.modelName = modelManager.getModelNamebyModelId(this.modelId);
        this._addHandlers();
        this.updateBoundingBox();
    }

    _addHandlers() {
        addHandlerForOperation(this.modelId, [this.modelId], this.updateBoundingBox.bind(this), this.branchId + "boundary",
            HANDLER_TYPE_ENUM.BOUNDARY, HANDLER_TYPE_ENUM.BOUNDARY);
    }

    updateBoundingBox() {
        const volumeBoundingBox = getCurrentBoundingBoxOfVolumesInWorld([this.branchId]);
        if (volumeBoundingBox) {
            this.bBox.copy(volumeBoundingBox);
        }
    }
}

export default Volume;
